import {APIResponse} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {UserDTO} from "./model/user/UserDTO";

export type Locale = "en" | "lt" | "pl";

class UserSettingsApiDefinition extends ApiDefinition{
    constructor() {
        super("/users/settings");
    }

    async userInfo(): Promise<APIResponse<UserDTO>> {
        return this.get();
    }

    async getLanguageBundle(locale: Locale = "en"): Promise<APIResponse<UserDTO>> {
        return this.get(`lang-${locale}.json`);
    }

    async getLanguageBundleProperties(locale: Locale): Promise<APIResponse<String>> {
        return this.get(`lang-${locale}.properties`);
    }
}

export const UserSettingsApi = new UserSettingsApiDefinition();